<template>
    <div :class="`col-12 col-md-${columnWidth}`">
        <label class="text-subtitle2" v-if="label">{{ label }}</label>
        <q-select
            v-model="model"
            :options="filteredOptions"
            :name="name"
            :data-cy="name"
            emit-value
            map-options
            outlined
            dense
            use-input
            input-debounce="0"
            @filter="filterFn"
            :rules="[
                (val) =>
                    !required ||
                    showTextField ||
                    (val !== null && val !== '' && val !== 'sep') ||
                    'Please select a value',
            ]"
            class="q-mb-sm"
        >
            <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope || {}"></slot>
            </template>
            <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" :disable="scope.opt.disable">
                    <q-item-section>
                        <q-item-label>{{ scope.opt.label }}</q-item-label>
                    </q-item-section>
                </q-item>
            </template>
        </q-select>

        <div v-if="showTextField">
            <q-input
                v-model="textModel"
                :name="textName"
                outlined
                dense
                :rules="[
                    (val) =>
                        !showTextField ||
                        (val !== null && val !== '') ||
                        'Please fill out this field',
                ]"
                :label="freeTextLabel || 'Free Text'"
            />
            <div class="text-caption text-grey" v-if="helpText">
                {{ helpText }}
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from "vue";

export default {
    props: {
        columnWidth: {
            type: [String, Number],
            default: 6,
        },
        label: String,
        name: String,
        options: {
            type: Array,
            default: () => [],
        },
        modelValue: [String, Number],
        textName: String,
        initialTextValue: String,
        required: Boolean,
        helpText: String,
        freeTextLabel: String,
    },
    setup(props, { emit }) {
        const model = ref(props.modelValue);
        const textModel = ref(props.initialTextValue);
        const filteredOptions = ref(props.options);

        const showTextField = computed(() => model.value == "0");

        watch(
            () => props.modelValue,
            (val) => {
                model.value = val;
            },
        );

        watch(model, (val) => {
            emit("update:modelValue", val);
        });

        watch(
            () => props.options,
            (val) => {
                filteredOptions.value = val;
            },
        );

        const filterFn = (val, update) => {
            if (val === "") {
                update(() => {
                    filteredOptions.value = props.options;
                });
                return;
            }

            update(() => {
                const needle = val.toLowerCase();
                filteredOptions.value = props.options.filter(
                    (v) => v.label.toLowerCase().indexOf(needle) > -1,
                );
            });
        };

        return {
            model,
            textModel,
            filteredOptions,
            showTextField,
            filterFn,
        };
    },
};
</script>
